export const ATLAS_ROLES = ['Atlas.Viewer', 'Atlas.Editor', 'Atlas.Admin'];
/** Role hierarchy: Admin > Editor > Viewer */
const ROLE_RANK = {
    'Atlas.Viewer': 1,
    'Atlas.Editor': 2,
    'Atlas.Admin': 3,
};
export function hasMinimumRole(roles, required) {
    const userRank = Math.max(0, ...roles
        .filter((r) => ATLAS_ROLES.includes(r))
        .map((r) => ROLE_RANK[r]));
    return userRank >= ROLE_RANK[required];
}
export function isViewer(roles) {
    return hasMinimumRole(roles, 'Atlas.Viewer');
}
export function isEditor(roles) {
    return hasMinimumRole(roles, 'Atlas.Editor');
}
export function isAdmin(roles) {
    return hasMinimumRole(roles, 'Atlas.Admin');
}
export const ROLE_PERMISSIONS = {
    listMaps: 'Atlas.Viewer',
    getMap: 'Atlas.Viewer',
    createMap: 'Atlas.Admin',
    updateMap: 'Atlas.Admin',
    archiveMap: 'Atlas.Admin',
    listRecords: 'Atlas.Viewer',
    getRecord: 'Atlas.Viewer',
    createRecord: 'Atlas.Editor',
    updateRecord: 'Atlas.Editor',
    archiveRecord: 'Atlas.Editor',
    restoreRecord: 'Atlas.Editor',
    getStates: 'Atlas.Viewer',
    createImport: 'Atlas.Editor',
    commitImport: 'Atlas.Editor',
    cancelImport: 'Atlas.Editor',
    createExport: 'Atlas.Viewer',
    getHistory: 'Atlas.Editor',
    restoreVersion: 'Atlas.Admin',
};
//# sourceMappingURL=roles.js.map